import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { cn } from '@/lib/utils';

import RuleBuilderAggregateAttribute from './RuleBuilderAggregateAttribute';
import RuleBuilderRemoveButton from './RuleBuilderRemoveButton';
import RuleBuilderText from './RuleBuilderText';
import type {
  AggregatePath,
  AndConditionPath,
  RuleBuilderObjectType,
  RuleEntityType,
} from './types';
import { useAudienceRuleForm } from './types';

type Props = {
  basePath: AndConditionPath;
  ruleEntity: RuleEntityType;
  object: RuleBuilderObjectType;
  disabled?: boolean;
  onConditionRemove: () => void;
};

const buildAggregatePath = (basePath: AndConditionPath): AggregatePath => `${basePath}.aggregate`;

const RuleBuilderMultiConditionHeader = ({
  basePath,
  ruleEntity,
  disabled = false,
  onConditionRemove,
}: Props) => {
  const form = useAudienceRuleForm();

  return (
    <div className="flex w-full flex-1 items-start justify-start gap-6">
      <div
        className={cn(
          'flex items-start justify-start gap-6',
          'max-xl:gap-x-4.5 max-xl:gap-y-2',
          'max-lg:gap-x-3 max-lg:gap-y-1.5',
          'max-sm:flex-1 max-sm:flex-col',
        )}
      >
        <div className="flex items-center gap-2">
          {ruleEntity.icon}
          <RuleBuilderText variant="body1">{ruleEntity.name}</RuleBuilderText>
        </div>
        {ruleEntity.cardinality === 'many' && !ruleEntity.hideAggregate && (
          <RuleBuilderAggregateAttribute
            form={form}
            fields={buildAggregatePath(basePath)}
            className="max-[650px]:pl-13"
            disabled={disabled}
            operatorVariant={ruleEntity.aggregateFunction === 'sum' ? 'number' : 'count'}
          />
        )}
      </div>
      <RuleBuilderRemoveButton
        title={<Trans>Remove rule</Trans>}
        aria-label={t`Remove rule`}
        disabled={disabled}
        onClick={onConditionRemove}
      />
    </div>
  );
};

export default RuleBuilderMultiConditionHeader;
